// Auto-generated catalogue loaded from catalogue.json
// To add/edit products, modify files in public/catalogue/details/
// Then run: node scripts/build-catalogue.js (runs automatically on start/build)

import data from './catalogue.json';

const catalogue = data.catalogue;

export const CATEGORIES = data.categories;

export function findBySlug(categorySlug, productSlug) {
  return catalogue.find(
    (p) => p.categorySlug === categorySlug && p.slug === `${categorySlug}/${productSlug}`
  );
}

export default catalogue;
